export default function IconGoogleDrive({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <path d="M3.29688 16.5391H14.5949L17.0538 12.2266H5.75141L3.29688 16.5391Z" fill="none" />
      <path
        d="M3.29688 16.5391H14.5949L17.0538 12.2266H5.75141L3.29688 16.5391Z"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9661 12.2265H17.052L11.4342 2.17188H6.34766C6.58412 2.57725 11.9661 12.2265 11.9661 12.2265Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.34925 2.17188L0.734375 11.9181L3.296 16.539C3.296 16.539 8.65787 7.11616 8.89219 6.71509L6.34925 2.17188Z"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
